import React from 'react'

import { ProductChartMatchList } from 'modules/ProductChartMatches/containers'

import { AdminHeader, Layout } from 'components'

const ProductChartMatchesPage = () => (
  <Layout>
    <AdminHeader/>
    <ProductChartMatchList />
  </Layout>
)

export default ProductChartMatchesPage
